import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthService {

  constructor(private oauthService: OAuthService) { }

  isLoggedIn() {
    return this.oauthService.hasValidAccessToken();
  }

  get currentUser() {
    return this.oauthService.getIdentityClaims();
  }

  get currentRoles(): string[] {
    const claims: any = this.oauthService.getIdentityClaims();
    if (!claims) return [];

    // Check various standardized locations for roles
    // Keycloak often puts them in realm_access.roles or resource_access.client.roles
    if (claims.realm_access && claims.realm_access.roles) {
      return claims.realm_access.roles;
    }

    // Or just a direct list if configured that way
    if (claims.roles) {
      return claims.roles;
    }

    if (claims.authorities) {
      return claims.authorities;
    }

    return [];
  }

  public isTwoFaRequired(): boolean {
    console.log(localStorage.getItem('2fap'));
    if (localStorage.getItem('2fap') === 'passed') {
      return false;
    }
    return this.isTwoFaActive();
  }

  public isTwoFaActive(): boolean {
    return this.currentRoles.indexOf('ROLE_TWO_FACTOR_AUTHENTICATED') > -1;
  }

  get isStep() {
    return this.isAdmin || this.currentRoles.indexOf('ROLE_STEP') > -1;
  }

  get isInstructor() {
    return this.currentRoles.indexOf('ROLE_INSTRUCTOR') > -1;
  }

  get isCompany() {
    return this.currentRoles.indexOf('ROLE_COMPANY') > -1;
  }

  get isAdmin() {
    return this.currentRoles.indexOf('ROLE_ADMIN') > -1;
  }

}
